export default __webpack_public_path__ + "static/media/filter.885195a6.svg";